// import * as apis from '@apis'

const Topics = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'newsplan-topics',
      'docTypeCode': 'NPTOPICS',
      /* 文档库ID */
      'docLib': 2
    }
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default Topics
